import { IUploadedMediaResp, IUploadOptions } from 'src/types'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

class MediaService extends EnhancedWithAuthHttpService {
  private DEFAULT_COMPRESSION = [100, 500, 1000]

  constructor() {
    super(new HttpService(axiosInstance))
  }

  async duplicateFile(sourceKey: string) {
    const resp = await this.post<[string], { sourceKey: string }>('aws-s3/duplicate', { sourceKey })
    return resp?.[0] || ''
  }

  duplicateFileWithCompression(sourceKey: string, options: IUploadOptions = {}) {
    return this.post<IUploadedMediaResp, { sourceKey: string }>(
      'aws-s3/duplicate',
      { sourceKey },
      {
        params: {
          compression: options.compression || this.DEFAULT_COMPRESSION,
          fullLink: true,
        },
      },
    )
  }

  async uploadFile(file: File) {
    const formData = new FormData()
    formData.append('file', file)

    const resp = await this.post<[string], FormData>('aws-s3/files', formData)

    return resp?.[0] || ''
  }

  async uploadFileFromUrl(url: string) {
    return this.post<IUploadedMediaResp, { url: string }>(
      'aws-s3/files/url',
      { url },
      { params: { compression: this.DEFAULT_COMPRESSION, fullLink: true } },
    )
  }

  async uploadPexelsVideosFromUrl(videoUrl: string, mediumVideoUrl: string, smallVideoUrl: string) {
    try {
      const videoResponse = await fetch(videoUrl)
      // const mediumVideoResponse = await fetch(mediumVideoUrl)
      // const smallVideoResponse = await fetch(smallVideoUrl)

      if (
        !videoResponse.ok
        // || !mediumVideoResponse.ok || !smallVideoResponse.ok
      ) {
        throw new Error('Failed to download videos')
      }

      const videoBlob = await videoResponse.blob()
      const mp4Blob = new Blob([videoBlob], { type: 'video/mp4' })
      // const mediumVideoBlob = await mediumVideoResponse.blob()
      // const smallVideoBlob = await smallVideoResponse.blob()

      const formData = new FormData()
      // const formMedium = new FormData()
      // const formSmall = new FormData()

      formData.append('file', mp4Blob)
      // formMedium.append('file', mediumVideoBlob)
      // formSmall.append('file', smallVideoBlob)

      const uploadedVideo = await this.post<IUploadedMediaResp, FormData>(
        'aws-s3/files',
        formData,
        {
          params: {
            fullLink: true,
            type: 'video.mp4',
          },
        },
      )
      // const uploadedVideoMedium = await this.post<IUploadedMediaResp, FormData>(
      //   'aws-s3/files',
      //   formData,
      //   {
      //     params: {
      //       fullLink: true,
      //     },
      //   },
      // )
      // const uploadedVideoSmall = await this.post<IUploadedMediaResp, FormData>(
      //   'aws-s3/files',
      //   formData,
      //   {
      //     params: {
      //       fullLink: true,
      //     },
      //   },
      // )

      return {
        link: uploadedVideo?.link,
        link_medium: null,
        link_small: null,
        link_large: null,
        dimensions: uploadedVideo?.dimensions,
      }
    } catch (error) {
      console.error('Error uploading Pexels videos:', error)
      return null
    }
  }

  uploadFileWithCompression(file: File, options: IUploadOptions = {}) {
    const formData = new FormData()
    formData.append('file', file)

    return this.post<IUploadedMediaResp, FormData>('aws-s3/files', formData, {
      params: {
        compression: options.compression || this.DEFAULT_COMPRESSION,
        fullLink: true,
      },
    })
  }

  async removeFile(key: string) {
    await this.delete(`aws-s3/files`, {
      params: { key },
    })
  }

  async removeFileWithCompression(key: string, compression: number[] = this.DEFAULT_COMPRESSION) {
    await this.delete('aws-s3/files', {
      params: { compression, key },
    })
  }
}

export const mediaService = new MediaService()

export default mediaService
